import {defineStore} from "pinia";

export const useChangeCompanyStore = defineStore("companySwitch", {
    state: () => {
        return {
            companyId: null as number | null,
        };
    },
});
